<!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details components/TaxDetailsAlert.vue -->
<template>
    <div
      v-if="shouldShow"
      class="text-sm leading-5 font-normal text-yellow-800 rounded-md bg-yellow-50 sm:p-5 m-8"
      
    >
      <!-- Heroicon name: exclamation -->
      <div class="flex items-center space-x-2 text-yellow-700">
      <svg
            class="h-5 w-5 text-yellow-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              fill-rule="evenodd"
            />
          </svg> <h3 class="text-sm leading-5 font-normal text-yellow-800">{{ $t("attention-needed") }}</h3>
      </div>
      <div class="flex space-x-2">
        <p></p>
        <p></p>
        <p></p>
        
        <span class="text-sm leading-5 font-normal text-yellow-800">
            You need to provide your tax details.
        </span>
      
      <router-link
        to="/tax-details"
        class="ml-2 text-blue-600 underline font-medium"
      >
        Complete Now →
      </router-link>
    </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    name: "TaxDetailsAlert",
    computed: {
      ...mapGetters(["get_profile"]),
      shouldShow() {
        // const fields = this.get_profile?.nic_fields || [];
        // const targetPriorities = [3, 4, 5, 6];
  
        // // Find any NIC field in the target priorities that has a value
        // const hasValid = fields.some(
        //   (f) =>
        //     targetPriorities.includes(f.priority) &&
        //     f.value &&
        //     f.value.trim() !== ""
        // );
  
        // // Show warning if none of them are filled
        // return !hasValid;
        const profileType = this.get_profile?.profile?.type;
        const nicFields = this.get_profile?.nic_fields || [];

        // Filter priority 3-6 fields with code 'TIN' and non-empty value
        const hasValidTIN = [3,4,5,6].some(priority => {
          const field = nicFields.find(n => n.priority === priority);
          return field && field.code === 'TIN' && field.value && field.value?.toString().trim() !== '';
        });

        return !hasValidTIN;
      },
    },
  };
  </script>
  